import { render, staticRenderFns } from "./OrgFound.vue?vue&type=template&id=329566cf&"
import script from "./OrgFound.vue?vue&type=script&lang=js&"
export * from "./OrgFound.vue?vue&type=script&lang=js&"
import style0 from "./OrgFound.vue?vue&type=style&index=0&id=329566cf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports